import * as React from 'react';
import { connect } from 'react-redux';
import { GlobalPrivateState } from 'src/api';
import { ConfigurationModel } from 'franke-trough-dependencies';
import { FormattedMessage } from 'react-intl';

import MESSAGES from './checkout.messages';

export interface  WashbasinDimensionsPartialCheckoutProps {
  configuration: GlobalPrivateState['configuration'];
}

export class WashbasinDimensionsPartialCheckout extends React.Component<WashbasinDimensionsPartialCheckoutProps> {
  public render() {
    const washBasinDimension = this.configuration && this.configuration.washBasinDimension;
    return (
      <div className="washbasin-dimensions-partial-line">
        <span className="configuration-name">
          <FormattedMessage {...MESSAGES.checkoutWashBasinDimensions} />
        </span>
        <div className="trough-partial-line">
          {washBasinDimension && (
            <ul>
              <li>
                <FormattedMessage {...MESSAGES.checkoutPlateDimensionsWidth} />: {washBasinDimension.plateWidth} mm
              </li>
              <li>
                <FormattedMessage {...MESSAGES.checkoutPlateDimensionsDepth} />: {washBasinDimension.plateDepth} mm
              </li>
              {washBasinDimension.typeOfInstallation !== 'without' && (
                <li>
                  <FormattedMessage {...MESSAGES.checkoutTypeOfInstallation} />: 
                  {washBasinDimension.typeOfInstallation === 'left' && (
                    <span> <FormattedMessage {...MESSAGES.checkoutTypeOfInstallationLeft} /></span>
                  )}
                  {washBasinDimension.typeOfInstallation === 'right' && (
                    <span> <FormattedMessage {...MESSAGES.checkoutTypeOfInstallationRight} /></span>
                  )}
                  {washBasinDimension.typeOfInstallation === 'with' && (
                    <span> <FormattedMessage {...MESSAGES.checkoutTypeOfInstallationWith} /></span>
                  )}
                </li>
              )}
              {
                washBasinDimension.cornerDesign !== 'none' && 
                washBasinDimension.cornerDesignPosition && 
                washBasinDimension.cornerDesignPosition.length > 0 && (
                  <li>
                    <FormattedMessage {...MESSAGES.checkoutCornerDesign} />: 
                    {washBasinDimension.cornerDesign === 'bevel' && (
                      <span> <FormattedMessage {...MESSAGES.checkoutCornerDesignBevel} /> </span>
                    )}
                    {washBasinDimension.cornerDesign === 'radius' && (
                      <span> <FormattedMessage {...MESSAGES.checkoutCornerDesignRadius} /> </span>
                    )}
                    {washBasinDimension.cornerDesignPosition.indexOf('left') > -1 && (
                      <span><FormattedMessage {...MESSAGES.checkoutLeft} /></span>
                    )}
                    {washBasinDimension.cornerDesignPosition.indexOf('left') > -1 && washBasinDimension.cornerDesignPosition.indexOf('right') > -1 && (
                      <span> & </span>
                    )}
                    {washBasinDimension.cornerDesignPosition.indexOf('right') > -1 && (
                      <span><FormattedMessage {...MESSAGES.checkoutRight} /></span>             
                    )}
                  </li>
                )
              }
            </ul>
          )}
        </div>
      </div>
    );
  }

  private get configuration(): ConfigurationModel | undefined {
    const { configuration } = this.props;
    return configuration && configuration.result;
  }
}

export const WashbasinDimensionsPartialCheckoutComponent = connect((state: GlobalPrivateState) => ({
  configuration: state.configuration,
  checkout: state.checkout,
}))(WashbasinDimensionsPartialCheckout);

export default WashbasinDimensionsPartialCheckout;